import { DevGroupModel } from "@/services/device"
import { i18n } from "@/utils/i18n"
const { t } = i18n.global
import eu from "@/assets/images/dataCenter/eu.png"
import cn from "@/assets/images/dataCenter/cn.png"
import ind from "@/assets/images/dataCenter/in.png"
import { icons } from "ant-design-vue/es/image/PreviewGroup"

export const userData = {
  dbuser_id: 0,
  data_center: "",
  name: "",
  created_at: "",
  contact: "",
  alias_name: "",
  dgroup_id: 0,
  template_max_num: 1,
  template_max_id: 0,
  team_name: "",
  team_id: 0,
  leader_id: 0,
  is_main: true,
  member_ext: false,
  permissions: [] as number[],
  project_max_id: 0
}
export const dateCenter = [
  { label: t("common.europe"), value: "eu", icon: eu },
  // { label: t("common.theUnitedStates"), value: "us" },
  // { label: t("common.australia"), value: "au" },
  { label: t("common.china"), value: "cn", icon: cn },
  { label: t("common.india"), value: "in", icon: ind }
]

export const registerType = [
  { label: t("register.phoneRegistration"), value: "phone" },
  { label: t("register.mailRegistration"), value: "mail" }
]

export const phonePrefix = [{ label: "+ 86", value: "86" }]

// monitor数据类型
export const dataType: Record<number | string, string> = {
  0: "BOOL",
  1: "UINT16",
  2: "UINT32",
  3: "UINT64",
  4: "INT16",
  5: "INT32",
  6: "INT64",
  7: "REAL", //FLOAT
  8: "LREAL", //DOUBLE
  9: "STRING"
}

// monitor数据类型
export const dataTypeMap: Record<string, string | number> = {
  BOOL: 0,
  UINT16: 1,
  UINT32: 2,
  UINT64: 3,
  INT16: 4,
  INT32: 5,
  INT64: 6,
  REAL: 7,
  LREAL: 8,
  STRING: 9
}

export const accessType: Record<number, string> = {
  0: t("common.read"),
  1: t("common.write"),
  2: t("common.readWrite")
}

export type TreeData = { title: string; key: number; children: Array<TreeData> }

export const moveItemToFirst = (array: any[], condition: any) => {
  const index = array.findIndex(condition)
  if (index !== -1) {
    const item = array.splice(index, 1)[0]
    array.unshift(item)
  }
  return array
}

export const buildTree = (
  list: Array<{ name: string; id: number; parent_id: number }>,
  pid = 0,
  classKey?: string,
  level = 1
): Array<TreeData> => {
  //数据权限处理
  if (pid == 0) {
    list.map((item: any) => {
      if (!list.some((k: any) => k.id == item.parent_id)) {
        item.parent_id = 0
      }
    })
  }
  const pItem = list.find((item) => item.id == pid)
  classKey = classKey || "group-tree-node"

  return list
    .filter((item) => item.parent_id == pid)
    .map((item) => {
      return {
        title: item.name,
        key: item.id,
        pid,
        level,
        class: `cus-tree-node ${classKey}-${item.id}`,
        refClassKey: `${classKey}-${item.id}`,
        pName: pItem?.name || "root",
        children: buildTree(list, item.id, classKey, level + 1)
      }
    })
}

export const filterMaxLevelNodes = (tree: any, arr: number[]) => {
  const nodeMap: any = {}

  // 构建节点映射表
  function buildNodeMap(nodes: any) {
    for (let node of nodes) {
      nodeMap[node.key] = node
      if (node.children) {
        buildNodeMap(node.children)
      }
    }
  }
  buildNodeMap(tree)

  // 查找某个节点的所有祖先节点
  function getAllAncestors(nodeId: number) {
    const ancestors = new Set()
    let currentNode = nodeMap[nodeId]
    while (currentNode && currentNode.pid) {
      ancestors.add(currentNode.pid)
      currentNode = nodeMap[currentNode.pid]
    }
    return ancestors
  }

  // 收集所有输入节点的祖先节点
  const allAncestors = new Map()
  arr.forEach((id) => {
    allAncestors.set(id, getAllAncestors(id))
  })

  // 过滤掉那些存在祖先节点的节点
  return arr.filter((id) => {
    const ancestors = allAncestors.get(id)
    return !arr.some((otherId) => otherId !== id && ancestors.has(otherId))
  })
}

export const getTreeLink = (treeData: Array<TreeData>, key: number): TreeData[] => {
  const result: TreeData[] = []
  const findNode = (data: TreeData[], targetKey: number): boolean => {
    for (const item of data) {
      if (item.key === targetKey) {
        result.push(item)
        return true
      }
      if (item.children && findNode(item.children, targetKey)) {
        result.push(item)
        return true
      }
    }
    return false
  }
  findNode(treeData, key)
  return result.length ? result.reverse() : []
}

export const formatTreeLink = (links: any[]) => {
  if (links.length <= 0) {
    return {
      fullName: "--",
      name: "--"
    }
  } else if (links.length > 0 && links.length <= 3) {
    return {
      fullName: links.map((item) => item.title).join(">"),
      name: links.map((item) => item.title).join(">")
    }
  } else if (links.length > 3) {
    return {
      fullName: links.map((item) => item.title).join(">"),
      name: `${links[0].title}...${links[Math.floor(links.length / 2)].title}...${links[links.length - 1].title}`
    }
  }
}

export const dongleStates = [
  { label: t("common.offline"), value: 0 },
  { label: t("common.online"), value: 1 }
]

export const alarmLevel = [
  {
    key: "minor",
    label: t("alarm.minor"),
    value: 1,
    tagStyle: { fontColor: "#856EE5", background: "#EAE4FF", iconColor: "#947AFF" }
  },
  {
    key: "mild",
    label: t("alarm.mild"),
    value: 2,
    tagStyle: { fontColor: "#3987E3", background: "#D9EAFF", iconColor: "#3F96FD" }
  },
  {
    key: "moderate",
    label: t("alarm.moderate"),
    value: 4,
    tagStyle: { fontColor: "#DDAF16", background: "#FDF3D1", iconColor: "#F6C318" }
  },
  {
    key: "severe",
    label: t("alarm.severe"),
    value: 8,
    tagStyle: { fontColor: "#E57844", background: "#FFE7DB", iconColor: "#FF854C" }
  },
  {
    key: "critical",
    label: t("alarm.critical"),
    value: 16,
    tagStyle: { fontColor: "#E05050", background: "#FEDEDE", iconColor: "#F95959" }
  }
]

export const alarmStateBtn = [
  {
    key: "total",
    label: t("message.total"),
    value: 0,
    color: "#2B63E0",
    activeStyle: {
      color: "#FFFFFF",
      background: "#2B63E0"
    }
  },
  {
    key: "alarm",
    label: t("alarm.alarm"),
    value: 1,
    color: "#E05050",
    activeStyle: {
      color: "#FFFFFF",
      background: "#F95959"
    }
  },
  {
    key: "response",
    label: t("alarm.response"),
    value: 2,
    color: "#3987E3",
    activeStyle: {
      color: "#FFFFFF",
      background: "#3F96FD"
    }
  },
  {
    key: "recovery",
    label: t("alarm.recovery"),
    value: 4,
    color: "#389862",
    activeStyle: {
      color: "#FFFFFF",
      background: "#3EA96D"
    }
  }
]
export const alarmState = [
  {
    key: "alarm",
    label: t("alarm.alarm"),
    value: 1,
    tagStyle: { fontColor: "#FFFFFF", background: "#F95959" }
  },
  {
    key: "response",
    label: t("alarm.response"),
    value: 2,
    tagStyle: { fontColor: "#FFFFFF", background: "#3F96FD" }
  },
  {
    key: "recovery",
    label: t("alarm.recovery"),
    value: 4,
    tagStyle: { fontColor: "#FFFFFF", background: "#3EA96D" }
  }
]

export const alarmEnable = [
  { key: "off", label: t("alarm.off"), value: 0 },
  { key: "on", label: t("alarm.on"), value: 1 }
]

export const HighHigh = 1
export const High = 2
export const LowLow = 4
export const Low = 8
export const LargeDeviation = 16
export const SmallDeviation = 32
export const on = 128
export const off = 256

export const alarmType = [
  { key: "HighHigh", label: t("alarm.HighHigh"), value: HighHigh },
  { key: "High", label: t("alarm.High"), value: High },
  { key: "Low", label: t("alarm.Low"), value: Low },
  { key: "LowLow", label: t("alarm.LowLow"), value: LowLow },
  { key: "LargeDeviation", label: t("alarm.LargeDeviation"), value: LargeDeviation },
  { key: "SmallDeviation", label: t("alarm.SmallDeviation"), value: SmallDeviation },
  { key: "on", label: t("alarm.on"), value: on },
  { key: "off", label: t("alarm.off"), value: off }
]

export const alarmMaxNum = 300

export const mapAlarm = {
  1: {
    showDot: true,
    label: t("common.alarmLevel1"),
    color: {
      border: "1px solid #F9E0E4",
      background: "#FFEBE9",
      dot: "#FF5C5A",
      color: "#B32318"
    },
    borderRadius: "11px"
  },
  2: {
    showDot: true,
    label: t("common.alarmLevel2"),
    color: {
      border: "1px solid #FCE9D7",
      background: "#FFF8E9",
      dot: "#FF903A",
      color: "#D46B08"
    },
    borderRadius: "11px"
  },
  3: {
    showDot: true,
    label: t("common.alarmLevel3"),
    color: {
      border: "1px solid #FFECB7",
      background: "#FEF3CF",
      dot: "#FFD02B",
      color: "#C88E19"
    },
    borderRadius: "11px"
  }
}

export const mapOnline = {
  0: {
    showDot: false,
    label: t("common.offline"),
    color: {
      border: "1px solid #EAEDEE",
      background: "#F4F6F8",
      color: "#5D5F61"
    },
    borderRadius: "6px"
  },
  1: {
    showDot: false,
    label: t("common.online"),
    color: {
      border: "1px solid #D0F3D5",
      background: "#DDFBE8",
      color: "#0F5A38"
    },
    borderRadius: "6px"
  }
}

export const mapSyncStat = {
  0: {
    showDot: false,
    label: t("device.syncState0"),
    color: {
      border: "1px solid #EAEDEE",
      background: "#F4F6F8",
      color: "#5D5F61"
    },
    borderRadius: "6px"
  },
  1: {
    showDot: false,
    label: t("device.syncState1"),
    color: {
      border: "1px solid #D0F3D5",
      background: "#DDFBE8",
      color: "#0F5A38"
    },
    borderRadius: "6px"
  }
}

//不需要填写数值的组件种类
export const componentnoaddress: ArrayAny = ["RCPNO", "RCPG", "ENRCPNO", "ENRCPNONAME", "ENRCPG", "ENRCPGNAME"]
